export const actions = {
    LOAD_BLOGS: "LOAD_BLOGS"
}